import type { Agency } from "@features/user"
import Button from "components/Button"
import useEnv from "hooks/useEnv"
import type { FC } from "react"
import type { Offer } from "../../offersList/offersListTypes"
import { useNewsletterStore } from "../store/newsletterStore"
import buildHtmlGea from "../templates/gea"
import buildHtmlGeaBrasil from "../templates/geaBrasil"
import buildHtmlGecontur from "../templates/gecontur"

interface Props {
  offers: Offer[]
  agency: Agency | undefined
}

const NewsletterPreview: FC<Props> = ({ offers, agency }) => {
  const { isGea, isGeaBrasil } = useEnv()
  const header = useNewsletterStore((s) => s.header)
  const customUrl = useNewsletterStore((s) => s.headerUrl)
  const { currency } = useEnv()

  const headerUrl = customUrl ? customUrl : header ? header.image : undefined

  const html = isGea
    ? buildHtmlGea(offers, currency, headerUrl, agency)
    : isGeaBrasil
      ? buildHtmlGeaBrasil(offers, currency, headerUrl, agency)
      : buildHtmlGecontur(offers, headerUrl)

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(html)
    } catch (e) {
      console.error("Failed to copy newsletter HTML", e)
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="rounded border border-gray-200 overflow-hidden">
        <iframe
          title="newsletter-preview"
          srcDoc={html}
          className="w-full"
          style={{ height: 600 }}
        />
      </div>
      <div className="flex justify-center">
        <Button primary medium onClick={copyToClipboard}>
          Copiar HTML da Newsletter
        </Button>
      </div>
    </div>
  )
}

export default NewsletterPreview
